import { useQuery } from '@tanstack/react-query';
import { XMarkIcon } from '@heroicons/react/24/outline';
import backend from '../../services/backend';
import { Button } from '../../catalyst/button';
import { Dialog, DialogBody, DialogTitle } from '../../catalyst/dialog';
import { CollapsibleYamlView } from '../../components/CollapsibleYamlView';

// Fetches and displays the stored body of a single webhook delivery (DR-2336).
// Reuses the same CollapsibleYamlView viewer the delivery-row inspector uses so
// the payload reads consistently with the rest of the tab.
export function WebhookPayloadDialog({
  projectId,
  deliveryId,
  open,
  onClose,
}: {
  projectId: string;
  deliveryId: number | null;
  open: boolean;
  onClose: () => void;
}) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['webhook-delivery-payload', projectId, deliveryId],
    queryFn: () => backend.getWebhookDeliveryPayload(projectId, deliveryId!).then((res) => res.data),
    enabled: open && deliveryId != null,
  });

  return (
    <Dialog open={open} onClose={onClose} size="5xl">
      <DialogTitle className="flex justify-between items-center">
        Webhook payload
        <Button outline onClick={onClose}>
          <XMarkIcon className="size-4" />
        </Button>
      </DialogTitle>
      <DialogBody>
        {isLoading ? (
          <p className="text-sm text-gray-500 dark:text-zinc-400">Loading payload…</p>
        ) : isError || data == null ? (
          <p className="text-sm text-red-600 dark:text-red-400">Failed to load payload.</p>
        ) : (
          <CollapsibleYamlView data={data} />
        )}
      </DialogBody>
    </Dialog>
  );
}
